export default __webpack_public_path__ + "static/media/ico-carakerja.913ae9a3.webp";